// extracted by mini-css-extract-plugin
export const root = "mix-media-grid-module--root--3RvP8";
export const gridItem = "mix-media-grid-module--gridItem--1KiO6";
export const image = "mix-media-grid-module--image--3Vi2I";
export const text = "mix-media-grid-module--text--wEUq7";